import styled from "styled-components";
import { Anchor } from "@ebscois/react-component-library";

export const StyledAnchor = styled(Anchor)`
  line-height: 18px;
  padding-bottom: ${({ theme }) => theme.space.sm};
  font-weight: ${({ theme }) => theme.font.weight.bold};
  font-weight: ${({ theme }) => theme.font.weight.semibold};

  @media print {
    display: none;
  }
`;

export const StyledGenericNamesWrapper = styled.div`
  display: none;

  @media print {
    display: block;
  }
`;
